import { parseAsInteger, useQueryState } from 'nuqs';
import { usePurchaseOrderDocumentsTableColumns } from '@/features/purchase-order/hooks/use-purchase-order-documents-table-columns';
import { useDataTable } from '@/hooks/use-data-table';
import { useGetPurchaseOrderDocuments } from '@/services/apis/queries/purchase-order/use-get-purchase-order-documents';
import type { PurchaseOrderDocument } from '@/types/core/purchase-order/purchase-order-document';

const DOCUMENTS_PAGE_KEY = 'documentsPage';
const DOCUMENTS_PER_PAGE_KEY = 'documentsPerPage';

export function usePurchaseOrderDocumentsTable(purchaseOrderId: string) {
  const columns = usePurchaseOrderDocumentsTableColumns();
  const [page] = useQueryState(
    DOCUMENTS_PAGE_KEY,
    parseAsInteger.withDefault(1),
  );
  const [perPage] = useQueryState(
    DOCUMENTS_PER_PAGE_KEY,
    parseAsInteger.withDefault(10),
  );
  const {
    data: documents,
    isPending,
    isFetching,
  } = useGetPurchaseOrderDocuments({
    id: purchaseOrderId,
    page,
    perPage,
  });

  const dataTable = useDataTable<PurchaseOrderDocument>({
    data: documents?.data ?? [],
    columns,
    pageCount: documents?.maxPage ?? 0,
    renderFallbackValue: '-',
    enableSorting: false,
    queryKeys: {
      page: DOCUMENTS_PAGE_KEY,
      perPage: DOCUMENTS_PER_PAGE_KEY,
    },
  });

  return {
    ...dataTable,
    isPending: isPending || isFetching,
  };
}
